<template>
    <div class="shoppingcart-close" v-on:click="$emit('close')">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="19" viewBox="0 0 20 19">
            <defs>
                <path id="xa" d="M8.028 11.691c2.55 2.636 5.13 5.298 8.427 7.202.709.41 1.838-.437 1.475-1.17-1.64-3.29-4.323-5.864-6.84-8.525 2.945-2.106 6.422-3.87 8.798-6.415.27-.289.026-.806-.433-.782-3.77.203-7.495 2.758-10.497 4.823C6.828 4.343 4.626 1.647 1.692.096 1.054-.242-.18.355.022 1.185c.767 3.16 3.24 5.702 5.53 7.99-2.73 1.992-5.855 4.782-5.528 7.708.074.657.758 1.354 1.467 1.04 1.46-.646 2.389-2.154 3.432-3.26a46.574 46.574 0 0 1 3.105-2.972z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <!--<mask id="xb" fill="#fff">
                    <use xlink:href="#a"/>
                </mask>-->
                <use :fill="color" xlink:href="#xa"/>
                <!--<g fill="#000000" mask="url(#xb)">
                    <path d="M0 0h21v20H0z"/>
                </g>-->
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#FF6B6B'
        }
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>